// Assicura che window.theme e window.theme.settings esistano
const debugMode =
    window.theme && window.theme.settings && typeof window.theme.settings.debug_mode !== "undefined"
        ? Number(window.theme.settings.debug_mode) // Assicura che sia un numero
        : 0; // Default a 0 (Nessuno) se non definito

if (debugMode === 2) {
    //  CODICE DI DEBUG PER window.dispatchEvent ---
    // Conserva una referenza alla funzione originale
    const originalWindowDispatchEvent = window.dispatchEvent;

    // Sovrascrivi window.dispatchEvent
    window.dispatchEvent = function(event) {
        console.groupCollapsed(`🐞🐞🐞 window.dispatchEvent: ${event.type} 🐞🐞🐞`);
        console.log("Evento:", event);
        console.log("Dettagli evento (event.detail):", event.detail);
        console.trace("Stack trace della chiamata a dispatchEvent");
        console.groupEnd();

        // Chiama la funzione originale per mantenere il comportamento standard
        return originalWindowDispatchEvent.apply(this, arguments);
    };

    console.log("🐞🐞🐞 Monitoraggio di window.dispatchEvent attivato.🐞🐞🐞");
}

// Funzione per il log generica
window.LOG = function(...args) {
    if (debugMode === 0) {
        // Nessuno
        return; // Non fare nulla se il debug è disabilitato
    }

    if (debugMode === 1) {
        // Semplice
        console.log(...args);
        return;
    }

    // Comportamento completo per debugMode === 2 (Completo)
    if (debugMode === 2) {
        try {
            const err = new Error();
            const stack = err.stack || "";
            const stackLines = stack.split("\n");
            let caller = "unknown";

            if (stackLines.length > 2 && stackLines[2]) {
                const callerLine = stackLines[2].trim();
                const funcMatch = callerLine.match(/^at\s+(?:new\s+)?([\w$.<>]+(?:\\[as\s+[\w$.<>]+\\])?)/);

                if (funcMatch && funcMatch[1]) {
                    caller = funcMatch[1];
                    const fileInFuncLineMatch = callerLine.match(/\(([^)]+:\d+:\d+)\)/);
                    if (fileInFuncLineMatch && fileInFuncLineMatch[1]) {
                        const filePath = fileInFuncLineMatch[1];
                        let shortFilePath = filePath.substring(filePath.lastIndexOf("/") + 1);
                        const queryIdx = shortFilePath.indexOf("?");
                        if (queryIdx !== -1) shortFilePath = shortFilePath.substring(0, queryIdx);
                        caller += ` (${shortFilePath})`;
                    }
                } else {
                    const fileMatch = callerLine.match(/at\s+([^\s(]+:\d+:\d+)/);
                    if (fileMatch && fileMatch[1]) {
                        const filePath = fileMatch[1];
                        let shortFilePath = filePath.substring(filePath.lastIndexOf("/") + 1);
                        const queryIdx = shortFilePath.indexOf("?");
                        if (queryIdx !== -1) shortFilePath = shortFilePath.substring(0, queryIdx);
                        caller = shortFilePath;
                    } else if (callerLine.startsWith("at ")) {
                        caller = callerLine.substring(3).trim();
                    }
                }
            }
            console.log("🚀", `[${caller}]`, ...args);
        } catch (e) {
            console.log("🚀", "[LOG_INTERNAL_ERROR]", ...args); // Log di base anche in caso di errore interno
            // Logga l'errore specifico della funzione LOG solo se in modalità '2' (Completo)
            console.error("Errore interno alla funzione LOG:", e);
        }
    }
};


// ---------------------------------------------------------------------
// ---------------------------------------------------------------------
// ---------------------------------------------------------------------

/* recupera la versione dello script theme.js */
let themeVersion;
try {
    const scripts = document.querySelectorAll('script[src*="theme.js"]');
    const themeScript = Array.from(scripts).find((script) => script.src.includes("theme.js"));
    if (themeScript) {
        const scriptUrl = new URL(themeScript.src);
        themeVersion = scriptUrl.searchParams.get("v");
    }
} catch (error) {
    LOG("Errore nell'ottenere la versione dello script:", error);
}

/* SEO - normalizza l'URL rimuovendo lo slash finale */
function normalizeTrailingSlashUrl() {
  try {
    const pathname = window.location.pathname;

    if (!pathname || pathname === "/" || !pathname.endsWith("/")) {
      return;
    }

    const normalizedPathname = pathname.replace(/\/+$/, "");
    const normalizedUrl = `${window.location.origin}${normalizedPathname}${window.location.search}${window.location.hash}`;

    window.location.replace(normalizedUrl);
  } catch (error) {
    LOG("Errore nella normalizzazione URL senza slash finale:", error);
  }
}
normalizeTrailingSlashUrl();

const enableConsole = false;
const enableIphone = false;

window.iphonelog = function(msg) {
  if(!enableConsole && !enableIphone) return;

  if(enableConsole) console.log(msg);

  if(!enableIphone) return;
  const boxId = '__iphone_log_box__';
  let box = document.getElementById(boxId);
  if (!box) {
    box = document.createElement('div');
    box.id = boxId;
    box.style.cssText = 'position:fixed;right:8px;bottom:8px;max-width:90vw;max-height:60vh;overflow:auto;z-index:999999;font:12px/1.4 system-ui; background:#111;color:#fff; padding:8px;border-radius:8px;';
    document.body.appendChild(box);
  }
  const line = document.createElement('div');
  line.style.cssText = 'border-top:1px solid #333;padding-top:4px;margin-top:4px;white-space:pre-wrap;word-break:break-word;';
  line.textContent = `${msg}`;
  box.prepend(line);
}

window.formatError = function(err){
  if (!err) return 'Unknown error';
  if (err instanceof Error) {
    return `${err.name}: ${err.message}\n${err.stack || ''}`;
  }
  try { return typeof err === 'object' ? JSON.stringify(err) : String(err); }
  catch { return String(err); }
}

window.addEventListener('error', (ev) => {
  iphonelog(`window.error: ${ev.message || '(no message)'} @ ${ev.filename || ''}:${ev.lineno || ''}:${ev.colno || ''}`);
}, true);

window.addEventListener('unhandledrejection', (ev) => {
  iphonelog(`unhandledrejection: ${formatError(ev.reason)}`);
});

async function themeComponent(url, isAsync = true, checkDom = false) {
  if (!url || url.trim() === '') {
    iphonelog('themeComponent: URL is empty or undefined', url);
    return;
  }

  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('res-', '').replace('.js', '');
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  window.themeloading = window.themeloading || {};

  if (window[className] || window.themeloading[className]) {
    return;
  }

  if (checkDom && document.querySelector(tagName) == null) {
    return;
  }
  iphonelog(`ℹ️ ${tagName}: Carico componente`);

  window.themeloading[className] = true;

  if (isAsync) {
    import(url).then(() => {
      iphonelog(`✅ ${tagName}: import completato (async)`);
    }).catch(err => {
      iphonelog(`❌ ${tagName}: import FALLITO (async): ${formatError(err)}`);
    }).finally(() => {
      window.themeloading[className] = false;
    });
  } else {
    try {
      await import(url);
      iphonelog(`✅ ${tagName}: import tentato (await)`);
    } catch (err) {
      iphonelog(`❌ ${tagName}: import FALLITO (await): ${formatError(err)}`);
    }
    window.themeloading[className] = false;
  }
}
window.themeComponent = themeComponent;
// Inizializza l'oggetto globalUtils se non esiste
window.globalUtils = window.globalUtils || {};

/**
 * Aggiorna i badge conteggio carrello in header (mobile + desktop).
 * Utile se il carrello era vuoto al load (prima non c’era il nodo) o se l’evento mc-cart-counter non parte sulla PDP.
 */
window.globalUtils.refreshHeaderCartCount = function () {
    return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (res) {
            if (!res.ok) return null;
            return res.json();
        })
        .then(function (cart) {
            if (!cart || typeof cart.item_count === "undefined") return;
            var count = cart.item_count;
            var text = String(count);
            document.querySelectorAll(".header-cart-quantity-badge").forEach(function (el) {
                el.textContent = text;
                el.style.fontSize = count > 9 ? "10px" : "11px";
                el.classList.toggle("d-none", count === 0);
                el.classList.toggle("d-flex", count > 0);
                el.setAttribute("aria-hidden", count === 0 ? "true" : "false");
            });
            try {
                window.dispatchEvent(new CustomEvent("mc:cart:updated", { detail: cart }));
            } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
            } catch (e) {}
        })
        .catch(function (err) {
            LOG("refreshHeaderCartCount:", err);
        });
};

/**
 * @function handleAddToCart
 * @memberof window.globalUtils
 * @description Gestisce l'aggiunta di un prodotto al carrello.
 * Restituisce una Promise che si risolve con la risposta API in caso di successo,
 * o si rigetta con l'oggetto errore in caso di fallimento.
 * Mostra un alert all'utente in caso di errore.
 * @param {string} variantId - L'ID della variante da aggiungere.
 * @param {number} [quantity=1] - La quantità di prodotto da aggiungere. Default 1.
 * @returns {Promise<object>} Una Promise che si risolve con i dati di successo o si rigetta con l'errore.
 */
window.globalUtils.handleAddToCart = function(variantId, quantity = 1) {
    return new Promise((resolve, reject) => {
        if (!variantId) {
            console.warn("globalUtils.handleAddToCart: variantId mancante.");
            reject({ message: "Variant ID mancante." });
            return;
        }

        if (typeof quantity !== "number" || quantity < 1) {
            console.warn("globalUtils.handleAddToCart: quantità non valida, impostata a 1.", quantity);
            quantity = 1;
        }

        const itemsPayloadForShopifyAPI = [
            {
                id: variantId,
                quantity: quantity, // Usa la quantità fornita o il default
            },
        ];

        McShopify.addToCart({
            items: itemsPayloadForShopifyAPI,
            onSuccess: (response) => {
                console.log(`🛒 Prodotto aggiunto (quantità: ${quantity}) tramite globalUtils.handleAddToCart:`, variantId, response);
                window.globalUtils.refreshHeaderCartCount();
                resolve(response);
            },
            onError: (errorResponse) => {
                console.error("Errore durante l'aggiunta al carrello (globalUtils.handleAddToCart):", errorResponse);
                reject(errorResponse);
            },
        });
    });
};

// Gestione checkbox carrello
function initCartCheckboxes() {
  const privacyCheckbox = document.getElementById('privacyCheck');
  const newsletterCheckbox = document.getElementById('newsletterCheck');
  const profilazioneCheckbox = document.getElementById('profilazioneCheck');
  
  if (privacyCheckbox) {
    privacyCheckbox.addEventListener('change', function() {
      if (!this.checked) {
        this.value = '';
      } else {
        this.value = 'accepted';
      }
    });
  }

  if (newsletterCheckbox) {
    const newsletterHidden = document.getElementById('newsletterConsentHidden');
    
    newsletterCheckbox.addEventListener('change', function() {
      if (newsletterHidden) {
        newsletterHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
  
  if (profilazioneCheckbox) {
    const profilingHidden = document.getElementById('profilingConsentHidden');
    
    profilazioneCheckbox.addEventListener('change', function() {
      if (profilingHidden) {
        profilingHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
}

// Inizializza le checkbox del carrello quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCheckboxes);
} else {
  initCartCheckboxes();
}

window.initCartCheckboxes = initCartCheckboxes;

// Gestione autoplay video
function initVideoAutoplay() {
  // Funzione per far partire un video
  function playVideo(video) {
    if (!video) return;
    
    // Assicurati che il video sia muto per l'autoplay
    if (!video.muted) {
      video.muted = true;
    }
    
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          LOG('Video autoplay avviato con successo');
        })
        .catch((error) => {
          LOG('Errore durante autoplay video:', error);
          // Se l'autoplay fallisce, prova di nuovo quando il video è caricato
          video.addEventListener('loadeddata', () => {
            video.play().catch(err => {
              LOG('Errore autoplay dopo loadeddata:', err);
            });
          }, { once: true });
        });
    }
  }

  // Traccia i video che sono stati avviati manualmente dall'utente
  const manuallyPlayedVideos = new WeakSet();

  // Funzione per gestire i video in una slide
  function handleVideoInSlide(slide) {
    if (!slide) return;
    
    const videoWrapper = slide.querySelector('.video-wrapper');
    // Controlla se il video ha data-autoplay="true"
    if (!videoWrapper || videoWrapper.getAttribute('data-autoplay') !== 'true') {
      return;
    }
    
    const video = slide.querySelector('video');
    if (video && video.paused) {
      playVideo(video);
    }
  }

  // Funzione per fermare i video in una slide
  function stopVideoInSlide(slide) {
    if (!slide) return;
    
    const video = slide.querySelector('video');
    // Non fermare i video che sono stati avviati manualmente dall'utente
    if (video && !video.paused && !manuallyPlayedVideos.has(video)) {
      video.pause();
    }
  }

  // Ascolta i click manuali sui video per non interferire
  document.addEventListener('click', (e) => {
    const video = e.target.closest('video');
    if (video && e.target.closest('.video-wrapper')) {
      // Se l'utente clicca play, segna il video come avviato manualmente
      if (video.paused) {
        manuallyPlayedVideos.add(video);
      }
    }
  }, true);

  // Ascolta anche gli eventi play del video
  document.addEventListener('play', (e) => {
    if (e.target.tagName === 'VIDEO' && e.isTrusted) {
      // Se il video viene avviato da un'interazione utente, segnalo
      manuallyPlayedVideos.add(e.target);
    }
  }, true);

  // Gestione video negli slider (Swiper)
  function initSliderVideoAutoplay() {
    // Traccia quale slide è attualmente attiva per ogni slider
    const activeSlides = new WeakMap();
    
    function handleSliderSlide(slider, force = false) {
      // Trova tutte le slide
      const slides = slider.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      // Trova la slide attiva (quella con classe swiper-slide-active)
      let activeSlide = null;
      
      slides.forEach((slide) => {
        if (slide.classList.contains('swiper-slide-active')) {
          activeSlide = slide;
        }
      });

      // Se non troviamo una slide attiva, usa la prima visibile
      if (!activeSlide) {
        slides.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0 && rect.top >= 0 && rect.left >= 0) {
            if (!activeSlide) {
              activeSlide = slide;
            }
          }
        });
      }

      // Se la slide attiva non è cambiata e non è forzato, non fare nulla
      const previousActive = activeSlides.get(slider);
      if (!force && previousActive === activeSlide) {
        return;
      }
      
      // Aggiorna la slide attiva
      activeSlides.set(slider, activeSlide);

      // Ferma tutti i video tranne quello nella slide attiva
      slides.forEach((slide) => {
        if (slide !== activeSlide) {
          const video = slide.querySelector('video');
          if (video) {
            // Resetta il flag quando si cambia slide
            manuallyPlayedVideos.delete(video);
            stopVideoInSlide(slide);
          }
        }
      });

      // Avvia il video nella slide attiva solo se ha data-autoplay e non è già in riproduzione
      if (activeSlide) {
        const videoWrapper = activeSlide.querySelector('.video-wrapper');
        // Controlla se il video ha data-autoplay="true"
        if (videoWrapper && videoWrapper.getAttribute('data-autoplay') === 'true') {
          const video = activeSlide.querySelector('video');
          if (video) {
            // Se il video è in pausa e non è stato avviato manualmente, avvialo
            if (video.paused && !manuallyPlayedVideos.has(video)) {
              handleVideoInSlide(activeSlide);
            }
          }
        }
      }
    }

    function setupSlider(slider) {
      // Prova diversi modi per ottenere l'istanza Swiper
      const swiperInstance = slider.swiper || slider._swiper || 
                            (slider.getSwiper && slider.getSwiper()) ||
                            (window.Swiper && slider.swiper);
      
      // Gestisci la slide iniziale dopo un breve delay
      setTimeout(() => handleSliderSlide(slider, true), 500);
      
      if (swiperInstance) {
        // Ascolta i cambi di slide tramite l'API Swiper
        swiperInstance.on('slideChange', () => {
          setTimeout(() => handleSliderSlide(slider, true), 200);
        });
        
        swiperInstance.on('slideChangeTransitionEnd', () => {
          handleSliderSlide(slider, true);
        });
      } else {
        // Approccio alternativo: ascolta i cambi di classe solo per swiper-slide-active
        let lastActiveSlide = null;
        const slideObserver = new MutationObserver(() => {
          const slides = slider.querySelectorAll('.swiper-slide');
          let currentActive = null;
          
          slides.forEach((slide) => {
            if (slide.classList.contains('swiper-slide-active')) {
              currentActive = slide;
            }
          });
          
          // Solo se la slide attiva è cambiata
          if (currentActive !== lastActiveSlide) {
            lastActiveSlide = currentActive;
            handleSliderSlide(slider, true);
          }
        });
        
        const slides = slider.querySelectorAll('.swiper-slide');
        slides.forEach((slide) => {
          slideObserver.observe(slide, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
      }
    }

    // Cerca slider esistenti
    const sliders = document.querySelectorAll('.swiper, mc-swiper');
    
    sliders.forEach((slider) => {
      setupSlider(slider);
    });

    // Usa MutationObserver per rilevare nuovi slider aggiunti dinamicamente
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Controlla se il nodo stesso è uno slider
            if (node.matches && (node.matches('.swiper') || node.matches('mc-swiper'))) {
              setTimeout(() => setupSlider(node), 500);
            }
            // Controlla se contiene slider
            const sliders = node.querySelectorAll && node.querySelectorAll('.swiper, mc-swiper');
            if (sliders) {
              sliders.forEach((slider) => {
                setTimeout(() => setupSlider(slider), 500);
              });
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Gestione video con data-autoplay (per video fuori dagli slider)
  const videoWrappers = document.querySelectorAll('.video-wrapper[data-autoplay="true"]');
  
  if (videoWrappers.length > 0) {
    // Usa Intersection Observer per far partire i video quando entrano nel viewport
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // Avvia quando almeno il 10% del video è visibile
    };

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const wrapper = entry.target;
          const video = wrapper.querySelector('video');
          
          if (video && video.paused) {
            playVideo(video);
          }
          
          // Se il video deve fare loop, continua a osservarlo
          // Altrimenti smetti di osservarlo dopo che è partito
          if (!video || !video.hasAttribute('loop')) {
            videoObserver.unobserve(wrapper);
          }
        } else {
          // Ferma il video quando esce dal viewport (opzionale)
          const wrapper = entry.target;
          const video = wrapper.querySelector('video');
          if (video && !video.paused && !video.hasAttribute('loop')) {
            video.pause();
          }
        }
      });
    }, observerOptions);

    // Inizializza ogni video wrapper
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      
      if (!video) {
        LOG('Video non trovato nel wrapper');
        return;
      }

      // Assicurati che il video sia muto per l'autoplay
      if (!video.muted) {
        video.muted = true;
      }

      // Se il video è già caricato, prova a farlo partire subito
      if (video.readyState >= 2) { // HAVE_CURRENT_DATA
        playVideo(video);
      } else {
        // Altrimenti aspetta che sia caricato
        video.addEventListener('loadeddata', () => {
          playVideo(video);
        }, { once: true });
      }

      // Osserva il wrapper per l'autoplay quando entra nel viewport
      videoObserver.observe(wrapper);
    });
  }

  // Inizializza l'autoplay per gli slider
  initSliderVideoAutoplay();
}

// Inizializza l'autoplay quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoAutoplay);
} else {
  initVideoAutoplay();
}

// Re-inizializza quando nuovi contenuti vengono caricati (per AJAX/dynamic content)
window.initVideoAutoplay = initVideoAutoplay;

/**
 * Tab orizzontali (.tab-scroll-mobile): su mobile il tab selezionato resta in vista (scroll orizzontale).
 */
(function initTabScrollMobileIntoView() {
  function isMobileTabStrip() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function scrollActiveTabIntoView(triggerEl) {
    if (!triggerEl || !triggerEl.closest || !isMobileTabStrip()) return;
    var scrollRoot = triggerEl.closest(".tab-scroll-mobile");
    if (!scrollRoot) return;
    var item = triggerEl.closest(".nav-item");
    var el = item || triggerEl;
    var rootRect = scrollRoot.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    var delta = 0;
    if (elRect.left < rootRect.left) {
      delta = elRect.left - rootRect.left;
    } else if (elRect.right > rootRect.right) {
      delta = elRect.right - rootRect.right;
    }
    if (!delta) return;
    scrollRoot.scrollTo({
      left: scrollRoot.scrollLeft + delta,
      behavior: "smooth",
    });
  }

  document.addEventListener("shown.bs.tab", function (e) {
    scrollActiveTabIntoView(e.target);
  });

  function runInitial() {
    if (document.body.classList.contains('webview')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll(".tab-scroll-mobile .nav-link.active").forEach(function (btn) {
          scrollActiveTabIntoView(btn);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitial);
  } else {
    runInitial();
  }
})();
